<ags-topbar
  [userConnected]="userConnected"
  [signout]="signout"
  [userChange]="userChange"
  [themingClassName]="themingClassName"></ags-topbar>
<div class="topbar-padding"></div>
